import loadable from '@loadable/component';

export const EmbedSearchWidgetApplyToVolopPageLoadable = loadable(
  () => import('./EmbedSearchWidgetApplyToVolopPage'),
  { resolveComponent: (module) => module.EmbedSearchWidgetApplyToVolopPage },
);
